
import respUtility from '@/mixins/respUtility';

export default {
  name: 'BrandBanner',
  mixins: [respUtility],
  props: {
    brandRating: {
      type: Object,
      default() { return {}; },
    },
    brandTopBanner: {
      type: Object,
      default() { return {}; },
    },
    loading: {
      type: Boolean,
      default: true,
    },
    isBrandPage: {
      type: Boolean,
    },
    isCollectionPage: {
      type: Boolean,
    },
    isMobile: {
      type: Boolean,
    },
  },
  data() {
    return {
      bannerTop: true,
    };
  },
  computed: {
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    isBannerTop() {
      return this.bannerTop && (this.isCollectionPage);
    },
    bgLogo() {
      return this.brandTopBanner?.bgLogo;
    },
    logo() {
      return this.brandTopBanner?.logo;
    },
    title() {
      return this.brandTopBanner?.title;
    },
  },
};
